import NavBar from '../NavBar';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Box, Heading, Text, Input, Link as ChakraLink, Select, Image } from '@chakra-ui/react';
import Footer from '../../Footer';
import ListItem from '../../components/ListItem';
import { JobPostMeta, useGetJobBoardJobsQuery } from '../../generated/graphql';
import { unslugifyList } from '../../shared/unslugify';

function JobBoard() {
    const [jobTitle, setJobTitle] = useState('');
    const [jobType, setJobType] = useState('');
    // TODO: No filters for graduation date on backend yet
    // const [graduationDate, setGraduationDate] = useState('');
    const [location, setLocation] = useState('');
    const { data: jobsData } = useGetJobBoardJobsQuery({
        variables: { jobBoardInput: { category: null } }
    });

    let jobItems: any = <>Loading...</>;
    if (jobsData) {
        jobItems = jobsData.getJobBoardJobs?.jobs
            .filter(
                (job) =>
                    (jobType === '' || job.types.includes(jobType)) &&
                    (location === '' || unslugifyList(job.locations).includes(location)) &&
                    (jobTitle === '' || new RegExp(jobTitle, 'i').test(job.title))
            )
            .map((job) => <JobItem key={job.slug} data={job}></JobItem>);
    }

    return (
        <>
            <NavBar></NavBar>
            <Box
                bgGradient="linear(to-r, #4747E6, #4EB5FF)"
                w="100%"
                p={50}
                display="flex"
                flexDirection="column"
            >
                <Heading
                    w="100%"
                    textAlign="center"
                    color="white"
                    marginY="12px"
                    size="lg"
                    fontSize="40px"
                    letterSpacing="-1px"
                >
                    PathMatch Job Board
                </Heading>
                <Input
                    value={jobTitle}
                    type="text"
                    placeholder="Search by Job Title"
                    maxWidth="724px"
                    background="white"
                    height="60px"
                    mx="auto"
                    borderRadius="100px"
                    pl="28px"
                    _focus={{
                        border: '2px solid',
                        borderColor: 'brand.500'
                    }}
                    onChange={(e) => setJobTitle(e.target.value)}
                />
            </Box>
            <Box
                mb="60px"
                maxWidth="1110px"
                margin="40px auto 0 auto"
                gridAutoColumns="1fr"
                gridColumnGap="28px"
                gridTemplateColumns=".4fr 1fr"
                gridTemplateRows="auto"
                display={{ lg: 'grid', md: 'block', sm: 'block' }}
            >
                <Box mb="40px">
                    <Heading fontSize="22px" marginBottom="8px" fontWeight="600">
                        Refine Your Search
                    </Heading>
                    <Select
                        placeholder="Job Type"
                        marginY="10px"
                        onChange={(e) => setJobType(e.target.value)}
                    >
                        <option value="Full-Time Position - Start Immediately">
                            Full Time Job Starting Now
                        </option>
                        <option value="Full Time Position - Starting Summer 2022">
                            Full Time Job Starting Summer 2022
                        </option>
                        <option value="Summer 2022 Full-Time Internship">
                            Full Time Internship Summer 2022
                        </option>
                        <option value="Summer 2022 Part-Time Internship">
                            Part Time Internship Summer 2022
                        </option>
                        <option value="Spring 2022 Part-Time Internship">
                            Part Time Internship Spring 2022
                        </option>
                        <option value="Winter 2021/2022 Part-Time Internship">
                            Part Time Internship Starting now
                        </option>
                    </Select>
                    {/* <Select
                        placeholder="Graduation Date"
                        marginY="10px"
                        onChange={(e) => setGraduationDate(e.target.value)}
                    >
                        <option value="Graduates">Graduated</option>
                        <option value="Students in the Class of 2022">2022</option>
                        <option value="Students in the Class of 2023">2023</option>
                        <option value="Students in the Class of 2024">2024</option>
                        <option value="Students in the Class of 2025">2025</option>
                    </Select> */}
                    <Select
                        placeholder="Location"
                        marginY="10px"
                        onChange={(e) => setLocation(e.target.value)}
                    >
                        <option value="Remote">Remote</option>
                        <option value="Atlanta">Atlanta</option>
                        <option value="Austin">Austin</option>
                        <option value="Boston">Boston</option>
                        <option value="Chicago">Chicago</option>
                        <option value="Dallas">Dallas</option>
                        <option value="Denver">Denver</option>
                        <option value="Los Angeles">Los Angeles</option>
                        <option value="New York">New York</option>
                        <option value="San Francisco">San Francisco</option>
                        <option value="San Jose">San Jose</option>
                        <option value="Seattle">Seattle</option>
                    </Select>
                </Box>
                <Box minHeight="50vh">{jobItems}</Box>
            </Box>
            <Footer></Footer>
        </>
    );
}

function JobItem({ data }: { data: JobPostMeta }) {
    return (
        <ChakraLink
            as={Link}
            to={`/job-board/${data.id}`}
            isExternal={true}
            _hover={{ textDecoration: 'none' }}
        >
            {' '}
            <ListItem
                display="grid"
                gridAutoColumns="1fr"
                gridTemplateColumns="minmax(100px, 100px) 1fr"
            >
                <Box
                    h="80px"
                    w="80px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="8px"
                    overflow="hidden"
                >
                    <Image src={data.company?.logo as string}></Image>
                </Box>

                <Box>
                    <Heading as="h4" fontSize="16px" fontWeight="600" color="midnight.300">
                        {data.company?.title}
                    </Heading>
                    <Heading as="h3" fontSize="24px" fontWeight="600" letterSpacing="-0.25px">
                        {data.title}
                    </Heading>
                    <Text fontSize="14px" marginTop="4px" color="midnight.300" fontWeight="500">
                        {unslugifyList(data.locations)}
                    </Text>
                </Box>
            </ListItem>
        </ChakraLink>
    );
}

export default JobBoard;
